import { ReactNode } from 'react';

import { classNameList } from 'utils/property';
import { capitalize } from 'utils/string';
import styles from './Button.module.scss';

interface IProps {
  children: ReactNode;
  className?: string;
  size?: 'small' | 'medium' | 'large';
  variant?: 'primary' | 'secondary' | 'tertiary' | 'selected' | 'danger';
  state?: 'normal' | 'hover' | 'focus' | 'pressed' | 'disabled' | 'loading';
  'data-testid'?: string;
  onClick?: () => void;
}

export const Button = ({
  children,
  className,
  size = 'medium',
  variant = 'primary',
  state = 'normal',
  'data-testid': testId,
  onClick
}: IProps): JSX.Element => {
  return (
    <button
      className={classNameList(
        styles.button,
        styles[`${capitalize(size)}`],
        styles[`${capitalize(variant)}`],
        styles[`${capitalize(state)}`],
        className && className
      )}
      disabled={state === 'disabled' || state === 'loading'}
      onClick={onClick}
      data-testid={testId}>
      {children}
    </button>
  );
};
